import { ToggleGroup, Options } from '@instructure/ui';
import {
  Badge,
  Tag,
  IconButton,
  Menu,
  IconExternalLinkLine,
  IconSettingsLine,
  Flex,
  Text,
} from '@smarterservices/smarter-ui';
import useSessionStore from '../../stores/session';
import useAppStore from '../../stores/app';

const Reconnect = () => {
  const { openDrawer } = useAppStore();
  const { reconnect, setTransferSessionSid } = useSessionStore();

  const renderOptionsMenu = (sessionSid) => {
    return (
      <Menu
        placement="bottom end"
        shouldContainFocus
        shouldReturnFocus
        mountNode={() => document.body} // Ensures the menu overlays everything
        trigger={
          <IconButton
            withBackground={false}
            withBorder={false}
            color="primary"
            size="small"
            screenReaderLabel="Session Options"
            margin="none"
            padding="none"
          >
            <IconSettingsLine />
          </IconButton>
        }
      >
        <Menu.Item onSelect={() => openDrawer('focus', sessionSid)}>
          <Flex alignItems="center">
            <Flex.Item margin="0 xx-small 0 0">
              <IconExternalLinkLine size="x-small" />
            </Flex.Item>
            <Flex.Item>
              <Text>Start Check-in</Text>
            </Flex.Item>
          </Flex>
        </Menu.Item>
        <Menu.Separator />
        <Menu.Item onSelect={() => setTransferSessionSid(sessionSid)}>
          <Flex alignItems="center">
            <Flex.Item margin="0 xx-small 0 0">
              <IconExternalLinkLine size="x-small" />
            </Flex.Item>
            <Flex.Item>
              <Text>Transfer</Text>
            </Flex.Item>
          </Flex>
        </Menu.Item>
      </Menu>
    );
  };

  return (
    <>
    {Object.keys(reconnect).length > 0 &&
        <ToggleGroup
        toggleLabel="This is the toggle button label for screenreaders"
        margin="none none xx-small none"
        defaultExpanded={false}
        summary={
            <Flex justifyItems="space-between" margin="none small none none">
            <Flex.Item>Reconnected Sessions</Flex.Item>
            <Flex.Item>
                <Badge
                count={Object.keys(reconnect).length}
                variant="danger"
                standalone
                />
            </Flex.Item>
            </Flex>
        }
        >
        
            <Options>
            {Object.entries(reconnect).map(([sessionSid, data]) => (
                <Options.Item key={`session_reconnect_${sessionSid}`}>
                <Flex alignItems="center">
                    <Flex.Item width="3rem">
                    <Tag size="small" text="21" />
                    </Flex.Item>
                   
                    <Flex.Item textAlign='start' shouldGrow>
                        {data.firstName} {data.lastName}
                    </Flex.Item>
                    <Flex.Item width="2rem" textAlign="end">
                        {renderOptionsMenu(sessionSid)}
                    </Flex.Item>
                </Flex>
                </Options.Item>
            ))}
            </Options>
        
        </ToggleGroup>
    }
  </>
  );
};

export default Reconnect;
